"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareInstanceSize = exports.instanceSizeFromString = exports.isInstanceSize = exports.InstanceSize = void 0;
const validation_1 = require("../validator/validation");
var InstanceSize;
(function (InstanceSize) {
    InstanceSize["Aito_2CPU_512MB_Arm"] = "Aito_2CPU_512MB_Arm";
    InstanceSize["Aito_2CPU_512MB"] = "Aito_2CPU_512MB";
    InstanceSize["Aito_2CPU_1GB_Arm"] = "Aito_2CPU_1GB_Arm";
    InstanceSize["Aito_2CPU_1GB"] = "Aito_2CPU_1GB";
    InstanceSize["Aito_2CPU_2GB_Arm"] = "Aito_2CPU_2GB_Arm";
    InstanceSize["Aito_1CPU_2GB"] = "Aito_1CPU_2GB";
    InstanceSize["Aito_2CPU_2GB_B"] = "Aito_2CPU_2GB_B";
    InstanceSize["Aito_2CPU_2GB"] = "Aito_2CPU_2GB";
    InstanceSize["Aito_2CPU_4GB_Arm"] = "Aito_2CPU_4GB_Arm";
    InstanceSize["Aito_2CPU_4GB"] = "Aito_2CPU_4GB";
    InstanceSize["Aito_2CPU_8GB_Arm"] = "Aito_2CPU_8GB_Arm";
    InstanceSize["Aito_2CPU_8GB"] = "Aito_2CPU_8GB";
    InstanceSize["Aito_2CPU_16GB"] = "Aito_2CPU_16GB";
    InstanceSize["Aito_4CPU_32GB"] = "Aito_4CPU_32GB";
    InstanceSize["Aito_8CPU_64GB"] = "Aito_8CPU_64GB";
    InstanceSize["Aito_16CPU_128GB"] = "Aito_16CPU_128GB";
    InstanceSize["Aito_32CPU_256GB"] = "Aito_32CPU_256GB";
    InstanceSize["Aito_48CPU_384GB"] = "Aito_48CPU_384GB";
})(InstanceSize = exports.InstanceSize || (exports.InstanceSize = {}));
exports.isInstanceSize = validation_1.isString.which((0, validation_1.satisfiesCondition)(s => s in InstanceSize));
function instanceSizeFromString(enumKey) {
    return InstanceSize[enumKey];
}
exports.instanceSizeFromString = instanceSizeFromString;
function instanceSizeToSize(is) {
    const isString = is.toString();
    if (isString.includes('GB')) {
        const ramGbAsString = is.toString().replace(/Aito_\d+CPU_(\d+)GB/, '$1');
        return Number.parseInt(ramGbAsString, 10);
    }
    else {
        const ramMbAsString = is.toString().replace(/Aito_\d+CPU_(\d+)MB/, '$1');
        return Number.parseInt(ramMbAsString, 10) / 1024;
    }
}
function compareInstanceSize(one, two) {
    const oneAsNumber = instanceSizeToSize(one);
    const twoAsNumber = instanceSizeToSize(two);
    return oneAsNumber - twoAsNumber;
}
exports.compareInstanceSize = compareInstanceSize;
//# sourceMappingURL=InstanceSize.js.map